import { call, put, takeLatest } from 'redux-saga/effects';
import { createNews } from '../../../services/news/news-service';
import { CREATE_NEWS_REQUEST, receiveCreateNews, createNewsFailed } from '../actions/create-news-actions';

function* handleCreateNews(action) {
    try {
        const result = yield call(createNews, action.payload);
        yield put(receiveCreateNews(result));
    } catch (error) {
        yield put(createNewsFailed(error));
    }
}

export function* watchCreateNews() {
    yield takeLatest(CREATE_NEWS_REQUEST, handleCreateNews);
}